import { gql } from 'apollo-boost';

export const addMinusKeywordsPacksMutation = gql`
    mutation addMinusKeywordsPacks($input: GdAddMinusKeywordsPacksInput!) {
        addMinusKeywordsPacks(input: $input) {
            addedItems {
                id
                minusKeywords
                name
            }
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
    }
`;

export const updateMinusKeywordsPacksMutation = gql`
    mutation updateMinusKeywordsPacks(
        $input: GdUpdateMinusKeywordsPacksInput!
    ) {
        updateMinusKeywordsPacks(input: $input) {
            updatedItems {
                id
                name
                minusKeywords
            }
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
    }
`;

export const deleteMinusKeywordsPacksMutation = gql`
    mutation deleteMinusKeywordsPacks(
        $input: GdDeleteMinusKeywordsPacksInput!
    ) {
        deleteMinusKeywordsPacks(input: $input) {
            deletedPackIds
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
    }
`;

export const updateAdGroupMinusKeywordsMutation = gql`
    mutation updateAdGroupMinusKeywords(
        $input: GdUpdateAdGroupMinusKeywordsInput!
    ) {
        updateAdGroupMinusKeywords(input: $input) {
            updatedAdGroupIds
        }
    }
`;
